module.exports = __webpack_public_path__ + "static/vasostrict-bottles-a5bc8f6a2869ec3a69f6945572fafcdb.png";